import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

const siteUrl = "https://pimpmyplace.fr";
const defaultTitle = "Pimp My Place | Agence immobilière à L’Isle-sur-la-Sorgue";
const defaultDescription = "Pimp My Place accompagne vos projets d'achat, vente et estimation immobilière à L'Isle-sur-la-Sorgue, Avignon et dans le Vaucluse.";

const pageMetadata = {
  "/": { title: defaultTitle, description: defaultDescription },
  "/biens": { title: "Biens immobiliers à vendre dans le Vaucluse | Pimp My Place", description: "Découvrez nos maisons, villas et appartements à vendre à L'Isle-sur-la-Sorgue, Avignon et dans le Vaucluse." },
  "/estimation": { title: "Estimation immobilière dans le Vaucluse | Pimp My Place", description: "Demandez une estimation immobilière claire et personnalisée à L'Isle-sur-la-Sorgue, Avignon ou dans le Vaucluse." },
  "/honoraires": { title: "Honoraires immobiliers fixes et transparents | Pimp My Place", description: "Consultez les honoraires fixes, transparents et sans pourcentage de Pimp My Place dans le Vaucluse." },
  "/agence": { title: "Mehdi, votre agent immobilier dans le Vaucluse | Pimp My Place", description: "Découvrez l'histoire, la mission et l'accompagnement humain de Mehdi, fondateur de Pimp My Place." },
  "/guides": { title: "Guides immobiliers locaux : Avignon, L'Isle-sur-la-Sorgue, Luberon | Pimp My Place", description: "Conseils pour vivre, investir, vendre et estimer un bien à Avignon, L'Isle-sur-la-Sorgue et dans le Luberon." },
  "/observatoire": { title: "Observatoire immobilier du Vaucluse | Pimp My Place", description: "Suivez les tendances immobilières qualitatives à Avignon, L'Isle-sur-la-Sorgue et dans le Luberon." },
  "/parrainage": { title: "Parrainage immobilier : gagnez 500 € | Pimp My Place", description: "Recommandez un vendeur dans le Vaucluse et recevez 500 € si la vente se concrétise avec Pimp My Place." },
  "/alertes": { title: "Alerte immobilière dans le Vaucluse | Pimp My Place", description: "Recevez les nouveaux biens à vendre qui correspondent à votre recherche dans le Vaucluse." },
  "/confidentialite": { title: "Confidentialité et cookies | Pimp My Place", description: "Consultez la politique de confidentialité, les données collectées et les choix cookies de Pimp My Place." },
  "/favoris": { title: "Mes biens favoris | Pimp My Place", description: "Retrouvez les biens immobiliers sauvegardés dans votre sélection Pimp My Place." },
};

export function Seo({ title, description, image }) {
  const location = useLocation();
  const setMeta = useCallback((selector, attribute, content) => {
    let tag = document.head.querySelector(selector);
    if (!tag) {
      tag = document.createElement("meta");
      const attributeName = selector.includes("property=") ? "property" : "name";
      tag.setAttribute(attributeName, attribute);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  }, []);
  const canonicalUrl = `${siteUrl}${location.pathname}`;
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "description", description);
    setMeta('meta[property="og:title"]', "og:title", title);
    setMeta('meta[property="og:description"]', "og:description", description);
    if (image) setMeta('meta[property="og:image"]', "og:image", image);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
  }, [canonicalUrl, description, image, setMeta, title]);
  return null;
}

export default function SiteSeo() {
  const location = useLocation();
  const metadata = pageMetadata[location.pathname] || {
    title: location.pathname.startsWith("/biens/") ? "Bien immobilier dans le Vaucluse | Pimp My Place" : defaultTitle,
    description: defaultDescription,
  };
  return <Seo {...metadata} />;
}